const mediaUrlById = new Map<string, string>()

export function saveMarketingMedia(mediaId: string, url: string) {
	mediaUrlById.set(mediaId, url)
}

export function getMarketingMediaUrl(mediaId: string | null | undefined) {
	if (!mediaId) {
		return null
	}

	return mediaUrlById.get(mediaId) ?? null
}
